import apiClient from '@/api/apiClient.js';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';


export default {
  namespaced: true,
    state: {
    schema: {},
    userData: {},
    filiationData: {},
    modelForm: {},
    tokensInstProfes: '',
    tokensAnamnesis: '',
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    userData: (state) => state.userData,
    filiationData: (state) => state.filiationData,
    modelForm: (state) => state.modelForm,
    tokensInstProfes: (state) => state.tokensInstProfes,
    tokensAnamnesis: (state) => state.tokensAnamnesis,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.userData = typeof recordsData?.modelForm?.userData === 'object' ? recordsData.modelForm.userData : {};
      state.filiationData = typeof recordsData?.modelForm?.filiationData === 'object' ? recordsData.modelForm.filiationData : {};
      state.modelForm = typeof recordsData?.modelForm?.reportData === 'object' ? recordsData.modelForm.reportData : {};
      state.tokensInstProfes = recordsData?.modelForm?.tokensInstProfes;
      state.tokensAnamnesis = recordsData?.modelForm?.tokensAnamnesis;
      state.isNewRecordDS = Boolean(recordsData?.isNewRecordDS);
    },
    SET_RECORDS_GENERATE(state, { recordsData }) {
      state.modelForm = typeof recordsData?.modelForm?.reportData === 'object' ? recordsData.modelForm.reportData : {};
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
    EXPORT_ERROR(state) {
      state.status = 'error';
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([apiClient.proPatientsCReportSchema()]);

        const [schemaRes] = responses.map((res) => res?.data ?? {});

        if (!schemaRes.schemaForm) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);

        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelProPatientsCReport(clinicalHistories_id, institutions_profes_id);
        let recordsData = res?.data?.data ?? [];
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async generateReport({ commit, rootState }, {part, sectionTextChange}) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);

        const res = await apiClient.createProPatientsCReport(
          clinicalHistories_id, 
          institutions_profes_id, 
          part, 
          sectionTextChange,
          { timeout: 270000 }
        );
        const recordsData = res?.data?.data ?? [];

        commit('SET_RECORDS_GENERATE', { recordsData });
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');

        const { clinicalHistories_id } = getAuthData(rootState);
        const preparedModel = prepareModel(rootState, model);

        await apiClient.updateProPatientsCReport(clinicalHistories_id, preparedModel);

        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async exportReport({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id, clinicalHistoriesHCPnum } = getAuthData(rootState);
        
        const res = await apiClient.proReportHCP(clinicalHistories_id, institutions_profes_id);
        const url = window.URL.createObjectURL(new Blob([res.data]));

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `HCP-${clinicalHistoriesHCPnum}.pdf`);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        link.remove();
      } catch (e) {
        console.error(e);
        commit('EXPORT_ERROR');
      }
    },
  },
};
